<template>
  <div
    class="relative youtube-video-with-modal cursor-pointer"
    :style="`background-image: url('${backgroundImageUrl}');`"
    @click="isShowingModal = true">
    <!--this padding is specific to the mc-play icon looking offset-->
    <div class="absolute-center z-level-1">
      <slot name="icon">
        <icon-halo
          class="absolute-center z-level-1"
          style="padding-left: 0.2em"
          :icon="icon"
          :size="iconSize"
          :halo-theme="iconHaloTheme"
          :border-theme="iconHaloBorderTheme"
          :border-thickness="iconHaloBorderThickness"
          :theme="iconHaloIconTheme"></icon-halo>
      </slot>
    </div>

    <youtube-video-modal
      :show="isShowingModal"
      :video-id="videoId"
      :autoplay="autoPlay"
      @modal:closed="hideModal">
    </youtube-video-modal>
  </div>
</template>

<script>
import useDom from "@/client/extensions/composition/useDom";


export default {
  setup(props) {
    let { isSmallerThanL } = useDom();

    return {
      isSmallerThanL,
    };
  },
  props: {
    videoId: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "mc-play",
    },
    iconSize: {
      type: Number,
      default: 3,
    },
    iconHaloTheme: {
      type: String,
      default: "lead",
    },
    iconHaloIconTheme: {
      type: String,
      default: "bg",
    },
    iconHaloBorderTheme: {
      type: String,
      default: "transparent",
    },
    iconHaloBorderThickness: {
      type: Number,
      default: 0,
    },
    autoPlay: {
      type: Boolean,
      default: true,
    },
    imageUrl: {
      type: [String, Boolean],
      default: false,
    },
    imageUrlMobile: {
      type: [String, Boolean],
      default: false,
    },
  },
  data: function () {
    return {
      isShowingModal: false,
    };
  },
  computed: {
    // ..https://img.youtube.com/vi/${videoId}/hqdefault.jpg

    backgroundImageUrl() {
      let youtubeImageUrl = `https://img.youtube.com/vi/${this.videoId}/hqdefault.jpg`;
      if (! this.isSmallerThanL) {
        return utilities.isNonEmptyString(this.imageUrl) ? this.imageUrl : youtubeImageUrl;
      }

      // mobile
      if (utilities.isNonEmptyString(this.imageUrlMobile)) {
        return this.imageUrlMobile;
      }

      if (utilities.isNonEmptyString(this.imageUrl)) {
        return this.imageUrl;
      }

      return youtubeImageUrl;
    },
  },
  methods: {
    showModal() {
      this.isShowingModal = true;
    },
    hideModal() {
      this.isShowingModal = false;
    },
    closeModal() {
      return this.hideModal();
    },
  },
};
</script>

<style scoped lang="scss">
.youtube-video-with-modal {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
